import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './PageBottomBar.scss';

const PageBottomBar = ({
    isShown,
    barContent,
    hasInitialized,
    hasBottomBarActive,
} = {}) => {
    const barClasses = classNames({
        'page-fixed-bottom-bar-layout__bar--shown': hasBottomBarActive,
        'page-fixed-bottom-bar-layout__bar': !hasBottomBarActive,
        'page-fixed-bottom-bar--shown': isShown && !hasBottomBarActive,
        'page-fixed-bottom-bar-layout--hidden':
            !hasInitialized && !hasBottomBarActive,
    });
    const content = isShown ? barContent : null;

    return <div className={barClasses}>{content}</div>;
};

PageBottomBar.propTypes = {
    isShown: PropTypes.bool,
    barContent: PropTypes.node,
    hasInitialized: PropTypes.bool,
    hasBottomBarActive: PropTypes.bool,
};

export default PageBottomBar;
